import React, { useState } from 'react'
import styled from 'styled-components'
import ContentLoader from 'react-content-loader'
import { makeFiltersLoaderContainer } from './mixins'

const LoaderContainer = styled.div`
  ${() => makeFiltersLoaderContainer()}
`

const FiltersPlaceholder = props => {
  // obtenemos el ancho de LoaderContainer
  const [wrapperWidth, setWrapperWidth] = useState(0)
  return (
    <LoaderContainer ref={node => node && setWrapperWidth(node.offsetWidth)}>
      <ContentLoader
        speed={2}
        width={wrapperWidth}
        height={685}
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        {...props}
      >
        <rect x="0" y="16" rx="4" ry="4" width="288" height="24" />
        <rect x="0" y="80" rx="8" ry="8" width="312" height="44" />
        <rect x="0" y="304" rx="8" ry="8" width="312" height="44" />
        <rect x="0" y="192" rx="8" ry="8" width="312" height="44" />
        <rect x="0" y="416" rx="8" ry="8" width="312" height="44" />
        <rect x="0" y="528" rx="8" ry="8" width="312" height="44" />
        <rect x="0" y="136" rx="8" ry="8" width="312" height="44" />
        <rect x="0" y="360" rx="8" ry="8" width="312" height="44" />
        <rect x="0" y="248" rx="8" ry="8" width="312" height="44" />
        <rect x="0" y="472" rx="8" ry="8" width="312" height="44" />
        <rect x="0" y="584" rx="8" ry="8" width="312" height="44" />
        <rect x="146" y="647" rx="4" ry="4" width="20" height="20" />
        <rect x="0" y="52" rx="4" ry="4" width="182" height="16" />
      </ContentLoader>
    </LoaderContainer>
  )
}

export default FiltersPlaceholder
